<template>
  <v-dialog
    v-model="dialog"
    persistent 
    width="500"
  >
    <v-card 
      v-if="value.length !==0" 
      class="py-5"
    >
      <div class="d-flex justify-center">  
        <div>
          <v-img
            width="100"
            :src="require('@/assets/logo/transferthirdparty.png')"
          /> 
        </div>
      </div> 
      <v-card-text> 
        <div
          class="text-center"
        >
          <h3>
            {{ $t('credit-owed-at') }}<br> 
            <div class="blue--text">
              "{{ value[0].game_type.name }}"
            </div>   
          </h3>
        </div> 
      </v-card-text> 
      <v-card-actions> 
        <v-row no-gutters> 
          <v-col cols="12">
            <v-btn 
              depressed
              block 
              :disabled="waitingStatus"
              :loading="waitingStatus"
              large
              class="mb-3 white--text"
              color="var(--bg-secondary-color)"
              @click="withdrawCredit (value[0].game_type.id)"
            >  
              {{ $t('button.withdraw-from') }} "{{ value[0].game_type.name }}" <br>
              {{ $t('button.back-richawin') }}
            </v-btn>  
          </v-col>
          <v-col cols="12"> 
            <v-btn 
              block
              depressed
              outlined
              dark   
              color="var(--bg-secondary-color)"
              @click="submit (value[0].game_type.id)"
            >
              <span>{{ $t('button.back-to-play') }} "{{ value[0].game_type.name }}"</span>
            </v-btn> 
          </v-col>
        </v-row> 
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { service as apiExternal } from '@/apis'    
import { IsInternalApp } from '@/plugins/checkType'
import * as c from '@/const/setTimeOutConfig' 

export default {
  data () {
    return {
      dialog:false,
      waitingStatus:false, 
      value : [],
      debounce : null
    }
  }, 
  watch : {
    value () {  
      if(this.value.length===0){ 
        this.dialog=false 
      }
    }
  },
  methods : { 
    async gotoExternalGame (id) {   
      var windowReference = IsInternalApp() ? window : window.open() ; 
      const [err,data] = await apiExternal.getLogin(id)
      
      if(err) {
        return
      }

      if(data && data.redirect_to) {  
        windowReference.location = data.redirect_to  
        this.$emit('loadCredit')   
      }  
    }, 
    async withdrawFormThirdPartyApi (id) {
      const [err,] = await apiExternal.putLogout(id)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }

      if(this.value.length>1){
        this.value.shift()  
        this.waitingStatus = false
      } else { 
        this.dialog = false
      } 
      this.$emit('loadCredit')    
    },
    async submit (id){   
      await this.gotoExternalGame(id)
      this.dialog=false 
    },
    async withdrawCredit (id){
      clearTimeout(this.debounce)
      this.debounce = setTimeout(()=>{
        this.waitingStatus = true
        this.withdrawFormThirdPartyApi(id) 
      },c.DEBOUNCBUTTON)
    },
    openDialog (value){ 
      this.waitingStatus = false
      this.value=value
      this.dialog = true
    }
  }, 
}
</script> 